module.exports = __webpack_public_path__ + "static/media/gold-ticket-transparent.147b6169.png";